import { match as collection } from "../../../src/params/collection.ts";

export const matchers = { collection };